/**
 * This file is the App entrypoint for POS embeds
 */

import { StrictMode } from 'react';

import { AppProvider, Frame } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/en.json';
import { Route, BrowserRouter, Routes, Navigate } from 'react-router-dom';

import PosIndexPage from './pages/PosIndexPage';
import StoresPage from './pages/StoresPage';
import SignatureCapture from '@/pos/components/SignatureCapture.tsx';

const router = (
    <BrowserRouter>
        <Frame>
            <Routes>
                <Route path="/shopify/auth" element={<Navigate to="/" replace />} />
                <Route path="/" element={<PosIndexPage />} />
                <Route path="/stores" element={<StoresPage />} />
                <Route path="/signature" element={<SignatureCapture />} />
            </Routes>
        </Frame>
    </BrowserRouter>
);

const GetPosApp = () => {
    return function App() {
        return (
            <StrictMode>
                <AppProvider i18n={translations}>{router}</AppProvider>
            </StrictMode>
        );
    };
};

export default GetPosApp;
